const SERVER_IP = "localhost";
const SERVER_PORT = "8000";

const TRANSPORTER_NAME = process.env.REACT_APP_CLIENT_NAME;

const USE_OVERLAY = true;

const getServerUrl = () => {
  const host = window.location.hostname;

  if (host.includes("localhost")) {
    return process.env.REACT_APP_LOCAL_URL;
  }

  const subdomain = host.split(".")[0];

  return `https://${subdomain}be.techiteasy.co.in`;
};


const getPrintUrl = () => {
  const host = window.location.hostname;
  const client = process.env.REACT_APP_CLIENT;

  const subdomain = host.split(".")[0];

  const match = subdomain.match(/\d+$/);
  const suffix = match ? match[0] : "";

  return client === "mk_log"
    ? `https://print${suffix}.techiteasy.co.in`
    : `https://printbe${suffix}.techiteasy.co.in`;
};

const getLocalFlag = () => {
  try {
    let lo = localStorage.getItem("local_flag") === "true";
    console.log("Inansdsnns", lo);
    return lo;
  } catch (e) {
    return false;
  }
};

var SERVER_URL = "";
if (getLocalFlag()) {
  console.log("in if");
  SERVER_URL = getServerUrl();
} else {
  console.log("in else");
  SERVER_URL = getServerUrl();
}

var NEW_PRINT = getPrintUrl();

export { SERVER_URL, USE_OVERLAY, TRANSPORTER_NAME, NEW_PRINT };